<template>
  <path
    d="M15.67 4.00024H14V3.00024C14 2.45024 13.55 2.00024 13 2.00024H11C10.45 2.00024 10 2.45024 10 3.00024V4.00024H8.33C7.6 4.00024 7 4.60024 7 5.33024V20.6602C7 21.4002 7.6 22.0002 8.34 22.0002H15.66C16.4 22.0002 17 21.4002 17 20.6702V5.33024C17 4.60024 16.4 4.00024 15.67 4.00024Z"
  />
</template>
